import { black, blue, darkGray, textGray } from 'modules/colors';
import { fonts, spacing } from 'modules/metrics';
import styled from 'styled-components';

import LandingFormWrapper from '../landingFormWrapper/LandingFormWrapper';

export const LandingFormWrapperStyled = styled(LandingFormWrapper)`
  padding-bottom: 100%;
`;

export const SectionsTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const SectionsTitle = styled.h1`
  font-size: ${fonts.xl}px;
  font-weight: 400;
  color: ${black};
  margin: 0;
`;

export const TitleLine = styled.hr`
  background-color: ${textGray};
  height: 2px;
  border: 0;
  width: 100%;
  margin: ${spacing.md}px 0 ${spacing.xl}px 0;
`;

export const Info = styled.div``;

export const Text = styled.p`
  line-height: 22px;
  margin-bottom: ${spacing.lg}px;
  color: ${darkGray};

  > a {
    color: ${blue};
  }
`;
